import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ChatComponent, HistoryComponent, SplitPaneComponent, SplitPaneVerticalComponent } from '@components';

interface OptimizationDraft {
  area: string;
  objective: string;
  rolloutStrategy: string;
}

@Component({
  selector: 'app-optimization',
  templateUrl: './optimization.page.html',
  styleUrls: ['./optimization.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent,
  ],
})
export class OptimizationPage {
  public optimizationSuggestions: any[] = [
    { icon: 'bi bi-lightning-charge', prompt: 'Identify the top 5 performance bottlenecks' },
    { icon: 'bi bi-currency-dollar', prompt: 'Suggest cost optimizations for this project' },
    { icon: 'bi bi-graph-up-arrow', prompt: 'Recommend reliability and latency improvements' },
  ];

  public optimizationContext: any = {
    page: 'optimization',
    purpose: 'Optimize performance, reliability, and cost across the project',
    areas: ['Frontend', 'API', 'Database', 'Infrastructure'],
    outputs: ['Optimization backlog', 'Quick wins', 'Risk notes'],
  };

  public creatingPlan = false;
  public optimizationError = '';
  public optimizationSuccess = '';
  public hasCreatedPlan = false;
  public optimizationDraft: OptimizationDraft = {
    area: '',
    objective: '',
    rolloutStrategy: '',
  };

  public readonly optimizationAreaOptions = ['Frontend performance', 'API latency', 'Database efficiency', 'Infrastructure cost'];
  public readonly rolloutStrategyOptions = ['Immediate rollout', 'Canary rollout', 'Phased rollout'];

  public async createOptimizationPlan(): Promise<void> {
    this.optimizationError = '';
    this.optimizationSuccess = '';
    this.hasCreatedPlan = false;

    if (!this.optimizationDraft.area.trim()) {
      this.optimizationError = 'Select an optimization area before creating a plan.';
      return;
    }
    if (!this.optimizationDraft.objective.trim()) {
      this.optimizationError = 'Provide a measurable objective before creating a plan.';
      return;
    }
    if (!this.optimizationDraft.rolloutStrategy.trim()) {
      this.optimizationError = 'Select a rollout strategy before creating a plan.';
      return;
    }

    this.creatingPlan = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasCreatedPlan = true;
      this.optimizationSuccess = 'Optimization plan created and ready for execution.';
    } finally {
      this.creatingPlan = false;
    }
  }
}
